export * from './atoms';

import { NavigationAtoms } from './atoms';

export const NavigationComponents = [
    ...NavigationAtoms
]